<!--<c-footer>-->
  <!-- <div>
    <a href="#" target="_blank">CoreUI</a>
    <span> &copy; 2022 creativeLabs</span>
  </div> -->
  <div>
    <!-- <a href="https://coreui.io/" target="_blank">CoreUI</a> -->
    <span>Version {{ BaseService.Version }}</span>
  </div>
  <div class="ms-auto">
    Powered by
    <a href="https://www.x2xecommerce.com/" target="_blank">
      <span> x2x eCommerce </span>
    </a>
  </div>
<!--</c-footer>-->
